import { useNavigate } from "react-router-dom";
import { Button, PageContainer, PremiumCard } from "components/ui";

const IconWarn = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

const PaymentCancel = () => {
  const navigate = useNavigate();
  return (
    <PageContainer narrow>
      <PremiumCard>
        <div style={{ textAlign: "center", padding: "32px 8px" }}>
          <div
            aria-hidden="true"
            style={{
              width: 80, height: 80, borderRadius: 20,
              background: "linear-gradient(135deg, var(--warning-bg), #FEF3C7)",
              color: "var(--warning)",
              display: "inline-flex", alignItems: "center", justifyContent: "center",
              margin: "0 auto 24px",
              boxShadow: "0 8px 24px rgba(245,158,11,0.18)",
            }}
          >
            <IconWarn />
          </div>
          <h2 className="t-heading-lg" style={{ margin: 0 }}>Payment cancelled</h2>
          <p className="t-body-sm t-muted" style={{ marginTop: 10, marginBottom: 28, maxWidth: 420, marginInline: "auto" }}>
            No worries — nothing was charged. You can try again whenever you're ready.
          </p>
          <div style={{ display: "inline-flex", gap: 10 }}>
            <Button variant="secondary" onClick={() => navigate("/tenant/dashboard")}>
              Back to dashboard
            </Button>
            <Button variant="primary" onClick={() => navigate("/tenant/subscribe")}>
              Try again
            </Button>
          </div>
        </div>
      </PremiumCard>
    </PageContainer>
  );
};

export default PaymentCancel;
